// import React, { useEffect, useState, useCallback } from "react";
// import api from "./api/axiosConfig";
// import Login from "./Login";
// import Sidebar from "./components/Sidebar";
// import { Routes, Route, useLocation } from "react-router-dom";
// import Users from "./pages/Users";
// import Dashboard from "./pages/Dashboard";
// import Topbar from "./components/Topbar";
// import CustomerModal from "./components/CustomerModal";
// import toast from "react-hot-toast";

// const downloadCSV = (data) => {
//   if (data.length === 0) return;

//   const headers = [
//     "Customer Name",
//     "Email",
//     "Plan Name",
//     "Status",
//     "Start Date",
//     "End Date",
//   ];

//   const csvRows = data.map((cust) =>
//     [
//       `"${cust.customerName}"`,
//       `"${cust.email}"`,
//       `"${cust.planName}"`,
//       `"${cust.subscriptionStatus}"`,
//       cust.startDate,
//       cust.endDate,
//     ].join(",")
//   );

//   const csvContent = [headers.join(","), ...csvRows].join("\n");

//   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//   const url = URL.createObjectURL(blob);

//   const link = document.createElement("a");
//   link.href = url;
//   link.download = "saas_customers_export.csv";

//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// function App() {
//   const location = useLocation();
//   const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);
//   const [role, setRole] = useState(localStorage.getItem("role"));

//   useEffect(() => {
//     if (role) {
//       setSidebarOpen(window.innerWidth >= 768);
//     }
//   }, [role]);

//   const [customers, setCustomers] = useState([]);

//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 10,
//   });

//   const [totalElements, setTotalElements] = useState(0);

//   const [status, setStatus] = useState("");
//   const [search, setSearch] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [planFilter, setPlanFilter] = useState("");

//   const [loading, setLoading] = useState(false);

//   const [openModal, setOpenModal] = useState(false);
//   const [editingId, setEditingId] = useState(null);

//   const [formData, setFormData] = useState({
//     customerName: "",
//     email: "",
//     planName: "",
//     subscriptionStatus: "ACTIVE",
//     startDate: "",
//     endDate: "",
//   });

//   const [emailError, setEmailError] = useState("");
//   const [dateError, setDateError] = useState("");

//   const isAdmin = role === "ADMIN";

//   // Check if user is authenticated on mount
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const storedRole = localStorage.getItem("role");
    
//     // If no token or role, clear everything and force login
//     if (!token || !storedRole) {
//       localStorage.clear();
//       setRole(null);
//       setCustomers([]);
//     }
//   }, []);

//   // Reset filters when navigating away from /users page
//   useEffect(() => {
//     if (location.pathname !== "/users") {
//       setStatus("");
//       setSearch("");
//       setDebouncedSearch("");
//       setPlanFilter("");
//       setPaginationModel({ page: 0, pageSize: 10 });
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setDebouncedSearch(search);
//       setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [search]);

//   const fetchCustomers = useCallback(async () => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       console.log("No token found, skipping fetch");
//       setRole(null);
//       setCustomers([]);
//       return;
//     }

//     setLoading(true);

//     try {
//       const { page, pageSize } = paginationModel;

//       let queryParams = `?page=${page + 1}&perPage=${pageSize}`;

//       if (planFilter) {
//         queryParams += `&plan=${planFilter}`;
//       }

//       const payload = {};

//       if (status === "true") {
//         payload.cdnboolisActive = true;
//       }

//       if (status === "false") {
//         payload.cdnboolisActive = false;
//       }

//       if (debouncedSearch?.trim()) {
//         payload.searchfirstName = debouncedSearch.trim();
//       }

//       const res = await api.post(`/user/customers${queryParams}`, payload);

//       if (Array.isArray(res.data)) {
//         const mappedCustomers = res.data.map((customer) => ({
//           _id: customer._id || customer.id,
//           id: customer._id || customer.id,
//           userId: customer.userId || "",
//           firstName: customer.firstName || "",
//           email: customer.email || "",
//           imgUrl: customer.imgUrl || "",
//           planStartDate: customer.planStartDate || "",
//           planEndDate: customer.planEndDate || "",
//           quantityCount: customer.quantityCount || 0,
//           locations: customer.locations || 0,
//           locationName: customer.locationName || [],
//           fb: customer.fb || 0,
//           insta: customer.insta || 0,
//           isActive: customer.isActive || false,
//           isPremium: customer.isPremium || false,
//           isFreeUser: customer.isFreeUser || false,
//         }));

//         const totalRecords = parseInt(
//           res.headers["x-total-records"] ||
//           res.headers["X-Total-Records"] ||
//           mappedCustomers.length
//         );

//         setCustomers(mappedCustomers);
//         setTotalElements(totalRecords);
//       }
//     } catch (err) {
//       console.error("Fetch customers error:", err);

//       // If 401, the interceptor will handle logout
//       // But we also clear local state here to be safe
     

//       toast.error(err.response?.data?.message || "Failed to fetch customers", {
//         duration: 3000,
//         position: "top-center",
//         style: {
//           background: "#ef4444",
//           color: "#fff",
//           fontWeight: "600",
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   }, [debouncedSearch, status, paginationModel, planFilter]);

//   useEffect(() => {
//     if (role) {
//       fetchCustomers();
//     }
//   }, [role, fetchCustomers]);

//   const handleLogout = () => {
//     // Reset all filters before logout
//     setStatus("");
//     setSearch("");
//     setDebouncedSearch("");
//     setPlanFilter("");
//     setPaginationModel({ page: 0, pageSize: 10 });

//     localStorage.removeItem("role");
//     localStorage.removeItem("token");
//     localStorage.removeItem("refreshToken");
//     localStorage.removeItem("email");

//     toast.success("Logged out successfully", {
//       duration: 2000,
//       position: "top-center",
//       style: {
//         background: "#10b981",
//         color: "#fff",
//         fontWeight: "600",
//       },
//     });

//     setRole(null);
//   };

//   const openAddCustomer = () => {
//     setEditingId(null);
//     setFormData({
//       customerName: "",
//       email: "",
//       planName: "",
//       subscriptionStatus: "ACTIVE",
//       startDate: "",
//       endDate: "",
//     });
//     setOpenModal(true);
//   };

//   const closeModal = () => {
//     setOpenModal(false);
//     setEditingId(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "email") setEmailError("");
//     if (name === "startDate" || name === "endDate") setDateError("");
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const now = new Date().toISOString();

//     try {
//       if (editingId) {
//         await api.put(`/user/customers/${editingId}`, {
//           ...formData,
//           updatedAt: now,
//         });

//         toast.success("Customer updated successfully", {
//           duration: 3000,
//           position: "top-center",
//           style: { background: "#10b981", color: "#fff", fontWeight: "600" },
//         });
//       } else {
//         await api.post(`/user/customers/create`, {
//           ...formData,
//           createdAt: now,
//           updatedAt: now,
//         });

//         toast.success("Customer created successfully", {
//           duration: 3000,
//           position: "top-center",
//           style: { background: "#10b981", color: "#fff", fontWeight: "600" },
//         });
//       }

//       setOpenModal(false);
//       fetchCustomers();
//     } catch (error) {
//       console.error(error);
//       toast.error(error.response?.data?.message || "Failed to save customer", {
//         duration: 4000,
//         position: "top-center",
//         style: { background: "#ef4444", color: "#fff", fontWeight: "600" },
//       });
//     }
//   };

//   const columns = [

//      {
//     field: "imgUrl",
//     headerName: "Profile",
//     flex: 0.5,
//     minWidth: 80,
//     sortable: false,
//     align: "center",
//     headerAlign: "center",
//     renderCell: (params) => {
//       const { row } = params;
//       return (
//         <div className="flex items-center justify-center">
//           {params.value ? (
//             <img
//   src={params.value}
//   alt={row.firstName || "User"}
//   referrerPolicy="no-referrer"
//   className="w-8 h-8 rounded-full object-cover ring-2 ring-slate-200 dark:ring-slate-600"
//   onError={(e) => {
//     e.target.onerror = null;
//     e.target.style.display = "none";
//     e.target.nextSibling.style.display = "flex";
//   }}
// />
//           ) : null}
//           <div
//             className="w-8 h-8 rounded-full bg-green-100 dark:bg-green-900 items-center justify-center text-green-700 dark:text-green-300 font-semibold text-xs"
//             style={{ display: params.value ? "none" : "flex" }}
//           >
//             {(row.firstName || "?")[0].toUpperCase()}
//           </div>
//         </div>
//       );
//     },
//   },
//     {
//       field: "firstName",
//       headerName: "Name",
//       flex: 1,
//       minWidth: 150,
//     },

//     {
//       field: "email",
//       headerName: "Email",
//       flex: 1.5,
//       minWidth: 200,
//     },


//         {
//       field: "isActive",
//       headerName: "Status",
//       flex: 0.8,
//       minWidth: 110,
//       sortable: false,
//       renderCell: (params) => {
//         const isActive = params.value;

//         return (
//           <span
//             className={`px-3 py-1 rounded-full text-xs font-bold ${
//               isActive
//                 ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300"
//                 : "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300"
//             }`}
//           >
//             {isActive ? "Active" : "Inactive"}
//           </span>
//         );
//       },
//     },

//     {
//       field: "planStartDate",
//       headerName: "Plan Start Date",
//       flex: 1,
//       sortable: false,
//       minWidth: 150,
//       renderCell: (params) => {
//         if (!params.value) return "N/A";
//         try {
//           const date = new Date(params.value);
//           return date.toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "short",
//             day: "numeric",
//           });
//         } catch {
//           return params.value;
//         }
//       },
//     },

//     {
//       field: "planEndDate",
//       headerName: "Plan End Date",
//       sortable: false,
//       flex: 1,
//       minWidth: 150,
//       renderCell: (params) => {
//         if (!params.value) return "N/A";
//         try {
//           const date = new Date(params.value);
//           return date.toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "short",
//             day: "numeric",
//           });
//         } catch {
//           return params.value;
//         }
//       },
//     },

//     {
//       field: "locationName",
//       headerName: "Location Name",
//       flex: 1.5,
//       minWidth: 180,
//       sortable: false,
//       renderCell: (params) => {
//         const locationNames = params.value || [];

//         if (locationNames.length === 0) {
//           return (
//             <span className="text-slate-400 dark:text-slate-500 italic">
//               No locations
//             </span>
//           );
//         }

//         const displayText = locationNames.join(", ");

//         return (
//           <div
//             className="truncate w-full text-slate-700 dark:text-slate-300"
//             title={displayText}
//           >
//             {displayText}
//           </div>
//         );
//       },
//     },

//     {
//       field: "quantityCount",
//       headerName: "Locations Subscribed",
//       flex: 0.8,
//       minWidth: 150,
//       align: "center",
//       headerAlign: "center",
//       renderCell: (params) => (
//         <span className="font-semibold text-slate-700 dark:text-slate-300">
//           {params.value || 0}
//         </span>
//       ),
//     },

// {
//   field: "social",
//   headerName: "Google / FB / IG",
//   flex: 1.2,
//   minWidth: 180,
//   sortable: false,
//   align: "center",
//   headerAlign: "center",
//   renderCell: (params) => {
//     const { row } = params;
//     return (
//       <div className="flex items-center justify-center gap-3">
//         {/* Google */}
//         <div className="flex items-center gap-1" title="Google Locations">
          
//           <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
//             {row.locations || 0}
//           </span>
//         </div>

//         <span className="text-slate-300 dark:text-slate-600 text-xs">|</span>

//         {/* Facebook */}
//         <div className="flex items-center gap-1" title="Facebook Pages">
          
//           <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
//             {row.fb || 0}
//           </span>
//         </div>

//         <span className="text-slate-300 dark:text-slate-600 text-xs">|</span>

//         {/* Instagram */}
//         <div className="flex items-center gap-1" title="Instagram Pages">
         
//           <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
//             {row.insta || 0}
//           </span>
//         </div>
//       </div>
//     );
//   },
// },



//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 0.8,
//       minWidth: 120,
//       sortable: false,
//       align: "center",
//       headerAlign: "center",
//       renderCell: (params) => {
//         const row = params.row;
//         const isActive = row.isActive;

//         const handleToggle = async (e) => {
//           e.stopPropagation();

//           try {
//             const response = await api.post("/user/customers/update-status", {
//               userId: row.userId,
//               isActive: !isActive,
//             });

//             const message =
//               response.data?.message ||
//               `Customer ${!isActive ? "activated" : "deactivated"} successfully`;

//             toast.success(message, {
//               duration: 2000,
//               position: "top-center",
//               style: { background: "#10b981", color: "#fff", fontWeight: "600" },
//             });

//             fetchCustomers();
//           } catch (error) {
//             console.error("Toggle status error:", error);

//             const errorMessage =
//               error.response?.data?.message || "Failed to update status";

//             toast.error(errorMessage, {
//               duration: 3000,
//               position: "top-center",
//               style: { background: "#ef4444", color: "#fff", fontWeight: "600" },
//             });
//           }
//         };

//         return (
//           <div className="flex items-center justify-center">
//             <button
//               onClick={handleToggle}
//               className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-1 focus:ring-offset-1 ${
//                 isActive
//                   ? "bg-green-600 focus:ring-green-500"
//                   : "bg-gray-300 focus:ring-gray-400"
//               }`}
//               title={isActive ? "Click to deactivate" : "Click to activate"}
//             >
//               <span
//                 className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
//                   isActive ? "translate-x-5" : "translate-x-1"
//                 }`}
//               />
//             </button>
//           </div>
//         );
//       },
//     },
//   ];

//   if (!role) return <Login onLogin={setRole} />;

//   return (
//     <div className="flex h-screen bg-gray-100 dark:bg-slate-900 overflow-hidden">
//       {/* Sidebar */}
//       <Sidebar
//         sidebarOpen={sidebarOpen}
//         setSidebarOpen={setSidebarOpen}
//         onDownloadCSV={() => downloadCSV(customers)}
//         onLogout={handleLogout}
//       />

//       {/* Mobile overlay when sidebar is open */}
//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}

//       {/* Main content area */}
//       <div
//         className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${
//           sidebarOpen ? "md:ml-64" : "md:ml-0"
//         }`}
//       >
//         {/* Topbar */}
//         <Topbar
//           customers={customers}
//           onLogout={handleLogout}
//           setSidebarOpen={setSidebarOpen}
//           sidebarOpen={sidebarOpen}
//         />

//         {/* Main content */}
//         <div className="flex-1 overflow-y-auto w-full">
//           <Routes>
//             {/* ✅ Home route now renders Dashboard component */}
//             <Route path="/" element={<Dashboard />} />

//             {/* Dashboard route (same component, accessible via /dashboard too) */}
//             <Route path="/dashboard" element={<Dashboard />} />

//             {/* Users Route */}
//             <Route
//               path="/users"
//               element={
//                 <Users
//                   customers={customers}
//                   columns={columns}
//                   loading={loading}
//                   paginationModel={paginationModel}
//                   setPaginationModel={setPaginationModel}
//                   totalElements={totalElements}
//                   search={search}
//                   setSearch={setSearch}
//                   openAddCustomer={openAddCustomer}
//                   status={status}
//                   setStatus={setStatus}
//                   planFilter={planFilter}
//                   setPlanFilter={setPlanFilter}
//                   isAdmin={isAdmin}
//                 />
//               }
//             />
//           </Routes>
//         </div>

//         {/* Customer Modal */}
//         <CustomerModal
//           open={openModal}
//           onClose={closeModal}
//           editingId={editingId}
//           formData={formData}
//           handleInputChange={handleInputChange}
//           handleSubmit={handleSubmit}
//           emailError={emailError}
//           dateError={dateError}
//         />
//       </div>
//     </div>
//   );
// }

// export default App;



// old version UAT 

import React, { useEffect, useState, useCallback } from "react";
import api from "./api/axiosConfig";
import Login from "./Login";
import Sidebar from "./components/Sidebar";
import { Routes, Route, useLocation } from "react-router-dom";
import Users from "./pages/Users";
import Dashboard from "./pages/Dashboard";
import Topbar from "./components/Topbar";
import CustomerModal from "./components/CustomerModal";
import toast from "react-hot-toast";

const downloadCSV = (data) => {
  if (data.length === 0) return;

  const headers = [
    "Customer Name",
    "Email",
    "Plan Name",
    "Status",
    "Start Date",
    "End Date",
  ];

  const csvRows = data.map((cust) =>
    [
      `"${cust.customerName}"`,
      `"${cust.email}"`,
      `"${cust.planName}"`,
      `"${cust.subscriptionStatus}"`,
      cust.startDate,
      cust.endDate,
    ].join(",")
  );

  const csvContent = [headers.join(","), ...csvRows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "saas_customers_export.csv";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function App() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);
  const [role, setRole] = useState(localStorage.getItem("role"));

  useEffect(() => {
    if (role) {
      setSidebarOpen(window.innerWidth >= 768);
    }
  }, [role]);

  const [customers, setCustomers] = useState([]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [totalElements, setTotalElements] = useState(0);

  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [planFilter, setPlanFilter] = useState("");

  const [loading, setLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    customerName: "",
    email: "",
    planName: "",
    subscriptionStatus: "ACTIVE",
    startDate: "",
    endDate: "",
  });

  const [emailError, setEmailError] = useState("");
  const [dateError, setDateError] = useState("");

  const isAdmin = role === "ADMIN";

  // Check if user is authenticated on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedRole = localStorage.getItem("role");
    
    // If no token or role, clear everything and force login
    if (!token || !storedRole) {
      localStorage.clear();
      setRole(null);
      setCustomers([]);
    }
  }, []);

  // Reset filters when navigating away from /users page
  useEffect(() => {
    if (location.pathname !== "/users") {
      setStatus("");
      setSearch("");
      setDebouncedSearch("");
      setPlanFilter("");
      setPaginationModel({ page: 0, pageSize: 10 });
    }
  }, [location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const fetchCustomers = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.log("No token found, skipping fetch");
      setRole(null);
      setCustomers([]);
      return;
    }

    setLoading(true);

    try {
      const { page, pageSize } = paginationModel;

      let queryParams = `?page=${page + 1}&perPage=${pageSize}`;

      if (planFilter) {
        queryParams += `&plan=${planFilter}`;
      }

      const payload = {};

      if (status === "true") {
        payload.cdnboolisActive = true;
      }

      if (status === "false") {
        payload.cdnboolisActive = false;
      }

      if (debouncedSearch?.trim()) {
        payload.searchfirstName = debouncedSearch.trim();
      }

      const res = await api.post(`/user/customers${queryParams}`, payload);

      if (Array.isArray(res.data)) {
        const mappedCustomers = res.data.map((customer) => ({
          _id: customer._id || customer.id,
          id: customer._id || customer.id,
          userId: customer.userId || "",
          firstName: customer.firstName || "",
          email: customer.email || "",
          imgUrl: customer.imgUrl || "",
          planStartDate: customer.planStartDate || "",
          planEndDate: customer.planEndDate || "",
          quantityCount: customer.quantityCount || 0,
          locations: customer.locations || 0,
          locationName: customer.locationName || [],
          fb: customer.fb || 0,
          insta: customer.insta || 0,
          isActive: customer.isActive || false,
          isPremium: customer.isPremium || false,
          isFreeUser: customer.isFreeUser || false,
        }));

        const totalRecords = parseInt(
          res.headers["x-total-records"] ||
          res.headers["X-Total-Records"] ||
          mappedCustomers.length
        );

        setCustomers(mappedCustomers);
        setTotalElements(totalRecords);
      }
    } catch (err) {
      console.error("Fetch customers error:", err);

      // If 401, the interceptor will handle logout
      // But we also clear local state here to be safe
     

      toast.error(err.response?.data?.message || "Failed to fetch customers", {
        duration: 3000,
        position: "top-center",
        style: {
          background: "#ef4444",
          color: "#fff",
          fontWeight: "600",
        },
      });
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, status, paginationModel, planFilter]);

  useEffect(() => {
    if (role) {
      fetchCustomers();
    }
  }, [role, fetchCustomers]);

  const handleLogout = () => {
    // Reset all filters before logout
    setStatus("");
    setSearch("");
    setDebouncedSearch("");
    setPlanFilter("");
    setPaginationModel({ page: 0, pageSize: 10 });

    localStorage.removeItem("role");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("email");

    toast.success("Logged out successfully", {
      duration: 2000,
      position: "top-center",
      style: {
        background: "#10b981",
        color: "#fff",
        fontWeight: "600",
      },
    });

    setRole(null);
  };

  const openAddCustomer = () => {
    setEditingId(null);
    setFormData({
      customerName: "",
      email: "",
      planName: "",
      subscriptionStatus: "ACTIVE",
      startDate: "",
      endDate: "",
    });
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setEditingId(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") setEmailError("");
    if (name === "startDate" || name === "endDate") setDateError("");
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const now = new Date().toISOString();

    try {
      if (editingId) {
        await api.put(`/user/customers/${editingId}`, {
          ...formData,
          updatedAt: now,
        });

        toast.success("Customer updated successfully", {
          duration: 3000,
          position: "top-center",
          style: { background: "#10b981", color: "#fff", fontWeight: "600" },
        });
      } else {
        await api.post(`/user/customers/create`, {
          ...formData,
          createdAt: now,
          updatedAt: now,
        });

        toast.success("Customer created successfully", {
          duration: 3000,
          position: "top-center",
          style: { background: "#10b981", color: "#fff", fontWeight: "600" },
        });
      }

      setOpenModal(false);
      fetchCustomers();
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to save customer", {
        duration: 4000,
        position: "top-center",
        style: { background: "#ef4444", color: "#fff", fontWeight: "600" },
      });
    }
  };

  const columns = [
    {
      field: "firstName",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      minWidth: 200,
    },

    {
      field: "planStartDate",
      headerName: "Plan Start Date",
      flex: 1,
      sortable: false,
      minWidth: 150,
      renderCell: (params) => {
        if (!params.value) return "N/A";
        try {
          const date = new Date(params.value);
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
        } catch {
          return params.value;
        }
      },
    },

    {
      field: "planEndDate",
      headerName: "Plan End Date",
      sortable: false,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        if (!params.value) return "N/A";
        try {
          const date = new Date(params.value);
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
        } catch {
          return params.value;
        }
      },
    },

    {
      field: "locationName",
      headerName: "Location Name",
      flex: 1.5,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        const locationNames = params.value || [];

        if (locationNames.length === 0) {
          return (
            <span className="text-slate-400 dark:text-slate-500 italic">
              No locations
            </span>
          );
        }

        const displayText = locationNames.join(", ");

        return (
          <div
            className="truncate w-full text-slate-700 dark:text-slate-300"
            title={displayText}
          >
            {displayText}
          </div>
        );
      },
    },

    {
      field: "quantityCount",
      headerName: "Locations Subscribed",
      flex: 0.8,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <span className="font-semibold text-slate-700 dark:text-slate-300">
          {params.value || 0}
        </span>
      ),
    },

    {
      field: "locations",
      headerName: "Locations Connected",
      flex: 0.8,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <span className="font-semibold text-slate-700 dark:text-slate-300">
          {params.value || 0}
        </span>
      ),
    },

    {
      field: "fb",
      headerName: "Facebook Pages",
      flex: 0.8,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <span className="font-semibold text-blue-600 dark:text-blue-400">
          {params.value || 0}
        </span>
      ),
    },

    {
      field: "insta",
      headerName: "Instagram Pages",
      flex: 0.8,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <span className="font-semibold text-pink-600 dark:text-pink-400">
          {params.value || 0}
        </span>
      ),
    },

    {
      field: "isActive",
      headerName: "Status",
      flex: 0.8,
      minWidth: 110,
      sortable: false,
      renderCell: (params) => {
        const isActive = params.value;

        return (
          <span
            className={`px-3 py-1 rounded-full text-xs font-bold ${
              isActive
                ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300"
                : "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300"
            }`}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 0.8,
      minWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const row = params.row;
        const isActive = row.isActive;

        const handleToggle = async (e) => {
          e.stopPropagation();

          try {
            const response = await api.post("/user/customers/update-status", {
              userId: row.userId,
              isActive: !isActive,
            });

            const message =
              response.data?.message ||
              `Customer ${!isActive ? "activated" : "deactivated"} successfully`;

            toast.success(message, {
              duration: 2000,
              position: "top-center",
              style: { background: "#10b981", color: "#fff", fontWeight: "600" },
            });

            fetchCustomers();
          } catch (error) {
            console.error("Toggle status error:", error);

            const errorMessage =
              error.response?.data?.message || "Failed to update status";

            toast.error(errorMessage, {
              duration: 3000,
              position: "top-center",
              style: { background: "#ef4444", color: "#fff", fontWeight: "600" },
            });
          }
        };

        return (
          <div className="flex items-center justify-center">
            <button
              onClick={handleToggle}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-1 focus:ring-offset-1 ${
                isActive
                  ? "bg-green-600 focus:ring-green-500"
                  : "bg-gray-300 focus:ring-gray-400"
              }`}
              title={isActive ? "Click to deactivate" : "Click to activate"}
            >
              <span
                className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
                  isActive ? "translate-x-5" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        );
      },
    },
  ];

  if (!role) return <Login onLogin={setRole} />;

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-slate-900 overflow-hidden">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        onDownloadCSV={() => downloadCSV(customers)}
        onLogout={handleLogout}
      />

      {/* Mobile overlay when sidebar is open */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content area */}
      <div
        className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${
          sidebarOpen ? "md:ml-64" : "md:ml-0"
        }`}
      >
        {/* Topbar */}
        <Topbar
          customers={customers}
          onLogout={handleLogout}
          setSidebarOpen={setSidebarOpen}
          sidebarOpen={sidebarOpen}
        />

        {/* Main content */}
        <div className="flex-1 overflow-y-auto w-full">
          <Routes>
            {/* ✅ Home route now renders Dashboard component */}
            <Route path="/" element={<Dashboard />} />

            {/* Dashboard route (same component, accessible via /dashboard too) */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Users Route */}
            <Route
              path="/users"
              element={
                <Users
                  customers={customers}
                  columns={columns}
                  loading={loading}
                  paginationModel={paginationModel}
                  setPaginationModel={setPaginationModel}
                  totalElements={totalElements}
                  search={search}
                  setSearch={setSearch}
                  openAddCustomer={openAddCustomer}
                  status={status}
                  setStatus={setStatus}
                  planFilter={planFilter}
                  setPlanFilter={setPlanFilter}
                  isAdmin={isAdmin}
                />
              }
            />
          </Routes>
        </div>

        {/* Customer Modal */}
        <CustomerModal
          open={openModal}
          onClose={closeModal}
          editingId={editingId}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          emailError={emailError}
          dateError={dateError}
        />
      </div>
    </div>
  );
}

export default App;